<div class="pl-pane__container--horizontal pl-pane--full-screen">
  <app-ngin-iframe path="dib_item/user_summary"></app-ngin-iframe>
</div>
